import Vue from 'vue'
import conceptTransformer from '@/transformers/purchase/lifting/concepts'

/**
 * @author Jose Luis R
 * @param id Quotation's id
 * @return {Object}
 */

const addConceptFile = ({ codename, ...payload }) => {
  const configs = {
    damage: "damage_photos/",
    GO: 'construction_generator/',
    FPD: 'construction_generator/final/',
  }

  return Vue.$http.post(`catalogs/common/${configs[codename]}`, conceptTransformer.sendFile(payload))
    .then(response => response.data)
    .catch((err) => { throw err })
}

export default addConceptFile



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/addConceptFile.js